export const DISCORD_LINK = 'https://discord.gg/cardashift';
export const TWITTER_LINK = 'https://twitter.com/cardashift';
export const MEDIUM_LINK = 'https://cardashift.medium.com/';
export const LINKEDIN_LINK = 'https://www.linkedin.com/company/cardashift';
export const TELEGRAM_LINK = 'https://t.me/+tlucM4-gnpE2Mjhk';
export const KYC_LINK = 'https://cardashift.medium.com/why-and-how-to-do-our-kyc-e58c10ef01cf'